
export function arrayToUrlHash(arr: {uuid: string, refId: string, title: string}[]): string {
    const joinedString = arr.map(x => `${x.uuid}:${x.refId}:${x.title}`).join(',');
    return btoa(joinedString);
}

export function urlHashToArray(hash: string): {uuid: string, refId: string, title: string}[] {
    const decodedString = atob(hash);
    return decodedString.split(',').map((x: string) => {
      const parts = x.split(':');
      return {uuid: parts[0], refId: parts[1], title: parts[2]};
    });
}
